export enum ChatMode {
  DEFAULT = 0,
  DIALOG = 1,
  SIDEBAR = 2
}
